import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";
import UserActions from "@/components/UserActions";
import { useAlbumNavigation } from '@/hooks/useAlbumNavigation';
import AutoFitText from '@/components/AutoFitText';

interface PageHeaderProps {
  title: string;
  backTo?: string;
  showUserActions?: boolean;
}

const PageHeader = ({
  title,
  showUserActions = true
}: PageHeaderProps) => {
  const { getAlbumPath } = useAlbumNavigation();
  const navigate = useNavigate();

  const handleBack = (e: React.MouseEvent) => {
    e.preventDefault();
    const path = getAlbumPath("/inicio");
    navigate(path);
  };

  return (
    <div className="sticky top-0 bg-background/95 backdrop-blur-sm border-b border-border z-50">
      <div className="max-w-4xl mx-auto px-4 py-4">
        <div className="relative flex items-center justify-between min-h-12">
          <div className="inline-flex items-center gap-3">
            <button
              onClick={handleBack}
              className="inline-flex items-center text-muted-foreground hover:text-foreground transition-colors"
              aria-label="Inicio"
            >
              <Home className="w-7 h-7" strokeWidth="1.5" />
            </button>
          </div>

          <div className="flex-1 px-4 min-w-0 overflow-visible">
            <AutoFitText
              as="h1"
              maxFont={28}
              minFont={16}
              lineHeight={1.45}
              verticalPaddingPx={6}
              opticalCenter={false}
              fontOpticalShiftY="var(--home-h1-optical-shift-y, 0em)"
              className="heading-top-offset text-2xl font-medium text-foreground text-center"
            >
              {title}
            </AutoFitText>
          </div>

          {showUserActions ? (
            <UserActions />
          ) : (
            <div></div>
          )}

        </div>
        {/* <div className="pt-3 text-center md:hidden flex justify-center">
          <h1 className="text-2xl font-medium text-foreground truncate max-w-[320px] md:max-w-none">{title}</h1>
        </div> */}
      </div>
    </div>
  );
};

export default PageHeader;
